import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import RegisterLoginButtons from 'modules/Common/components/RegisterLoginButtons';
import CollapsibleSection from 'modules/Common/components/CollapsibleSection';
import FootballMatchList from 'modules/Football/components/FootballMatchList';
import { SUBSCRIPTIONS_FOOTBALL_MATCH } from 'modules/Common/consts';

@connect((state, ownProps) => ({
  auth: state.common.auth,
  matchList: ownProps.matchList,
  subscriptions: state.common.userService.subscriptions
}))
export default class FootballMyScores extends Component {

  static propTypes = {
    auth: PropTypes.object.isRequired,
    matchList: PropTypes.array.isRequired,
    subscriptions: PropTypes.object.isRequired,
    hideIfEmpty: PropTypes.bool
  };

  isLoggedIn() {
    const {
      auth: {
        loggedIn = false,
        user
      } = {}
    } = this.props;

    return !!(loggedIn && user);
  }

  filterMatchesBySubscriptions(matchList = [], subscriptions = {}) {
    const myMatchSelectionIds = subscriptions[SUBSCRIPTIONS_FOOTBALL_MATCH];

    return matchList.filter(match => {
      const {
        match_reference: {
          id: matchId
        } = {}
      } = match;

      if (myMatchSelectionIds) {
        return myMatchSelectionIds[matchId] != null;
      }
      else {
        return false;
      }
    });
  }

  render() {
    const {
      hideIfEmpty = false,
      matchList = [],
      subscriptions = {}
    } = this.props;

    const selectedMatches = this.filterMatchesBySubscriptions(matchList, subscriptions);

    if (hideIfEmpty && selectedMatches.length === 0) {
      return null;
    }

    return (
      <div className="FootballMatchList">
        <CollapsibleSection title="My Scores">
          { this.isLoggedIn() ? this.renderLoggedIn(selectedMatches) : this.renderDefault() }
        </CollapsibleSection>
      </div>
    )
  }

  renderLoggedIn(selectedMatches) {
    return (
      selectedMatches.length ?
        <FootballMatchList matchList={selectedMatches}/>
      :
        <div className="matchlist-fav-container">
          <span className="matchlist-favs-info">Starring a match will add it to 'My Scores'. You'll also get goal notifications for this match.</span>
        </div>
    );
  }

  renderDefault = () => (
    <div className="matchlist-fav-container">
      <div className="matchlist-favs-info">
        <span className="matchlist-favs-msg">Log in or register for free to add matches to My Scores and then use the iOS app to receive score notifications direct to your phone during a game.</span>
        <RegisterLoginButtons/>
      </div>
    </div>
  );

}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballMyScores.js